const baseUrl = "https://www.travelwingsonline.in";

export const seoDefaults = {
  siteName: "Travel Wings Global",
  baseUrl,
  defaultTitle: "Travel Wings Global | Currency Exchange & Travel Services",
  defaultDescription:
    "Trusted forex, travel packages, visas, and insurance with transparent rates across India.",
  defaultOGImage: `${baseUrl}/logo.png`,
  defaultRobots: "index, follow",
};

export type SeoDefaults = typeof seoDefaults;
